import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { userStore } from '~/stores/UserStore';

import styles from './PointsPanel.module.scss';

type Props = {
  classNames?: string;
  disabled?: boolean | null;
};
const PointsPanel = ({ classNames, disabled }: Props) => {
  const { t } = useTranslation();
  const [showText] = useState(false);

  if (
    userStore.loyaltyPointsStore.showLoyaltyPointsOnFrontend !== true ||
    userStore.loyaltyPointsStore.loyaltyPoints === 0
  ) {
    return null;
  }

  return (
    <div
      className={classes([
        styles.companyPoints,
        classNames,
        disabled && styles._disabled,
      ])}
    >
      <label className={styles.panel}>
        <div className={styles.content}>
          <p className={styles.title}>
            {t('loyalty:checkout:spendPointsUse') + ' '}
            <p className={styles.pointsHighlight}>
              {userStore.loyaltyPointsStore.loyaltyPoints}
            </p>
            {' ' + t('loyalty:checkout:spendPointsPoints')}
          </p>
          <p className={styles.description}>
            {t('loyalty:checkout:payUpTo', {
              amount: `${userStore.loyaltyPointsStore.terms.paymentAmount}`,
            })}
          </p>
        </div>
        <input
          type="checkbox"
          className={styles.control}
          checked={userStore.loyaltyPointsStore.useLoyaltyPoints}
          onChange={() => userStore.loyaltyPointsStore.switchUseLoyaltyPoints()}
          disabled={Boolean(disabled)}
        />
      </label>
      {showText && <p className={styles.text}>{t('withoutPromocode')}</p>}
    </div>
  );
};

export default observer(PointsPanel);
